var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamtailor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1763_14726)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H23.9341V24H0V0ZM11.7508 7.92264C10.467 9.2156 9.47868 10.6286 8.5767 12.1002C7.66484 13.589 6.77473 15.0943 6.1444 16.7314C5.98154 17.1554 5.82725 17.6281 6.11736 18.0284C6.43451 18.4655 7.19604 18.7701 7.70374 18.6099C7.94901 18.5321 8.16 18.3877 8.36901 18.2413C8.51868 18.1358 8.66637 18.0284 8.81209 17.9176C8.94659 17.8154 9.09626 17.7158 9.2156 17.5965C9.26571 17.5536 9.78857 17.009 9.73516 16.9767C9.64681 16.9207 9.53934 16.9121 9.4378 16.9226C9.36593 16.9299 9.29341 16.9411 9.22286 16.9259C9.05736 16.8903 9.04022 16.7229 9.05736 16.5811C9.06725 16.4941 9.06725 16.4011 9.10088 16.3233C9.44901 15.5202 9.7444 14.6862 10.1684 13.9246C11.1125 12.2295 12.2802 10.6886 13.6029 9.26703C13.9444 8.89978 13.9503 8.68484 13.6338 8.28923C13.5415 8.17385 13.4347 8.06967 13.2626 7.8811C13.5837 7.8811 13.8119 7.86989 14.0387 7.88308C15.0686 7.9444 16.0985 8.0011 17.1264 8.08484C17.4092 8.10791 17.6018 8.02418 17.7297 7.79143C18.0105 7.27714 18.1312 6.72198 18.0732 6.13978C18.0316 5.72308 17.8576 5.56615 17.4349 5.5233C17.1297 5.49231 16.8218 5.46659 16.5152 5.46462C14.4125 5.44747 12.3264 5.65253 10.2626 6.03033C9.2967 6.20703 8.34593 6.49121 7.40769 6.78725C6.88747 6.95143 6.71275 7.54945 6.93297 8.10132C7.10374 8.52791 7.36088 8.60308 7.97407 8.42571C9.18462 8.0756 10.4314 8.00308 11.7521 7.9233L11.7508 7.92264Z",
    fill: "#F43F85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1763_14726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamtailor);
export default __webpack_public_path__ + "static/media/teamtailor.2ebda86e9cd8730fd5f440abb37e3ef7.svg";
export { ForwardRef as ReactComponent };